import { AsyncPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'percentage',
  templateUrl: './percentage.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, DecimalPipe],
})
export class PercentageComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  keyName: Observable<any> = new BehaviorSubject(null);
  constructor() {}

  ngOnInit(): void {}
}
